export default {
    print: {
        issueDelivery: {
            button: 'Printing a list of orders',
            // eslint-disable-next-line no-template-curly-in-string
            infoTitle: 'The task of issuing orders for delivery ${typeText} from ${date}',
        },

        tasks: ['Order', 'Track number of the order', 'Number of containers in the order', 'Status'],
    },

    actual: {
        text: 'Delivery to delivery',

        fields: {
            type: 'Task type',
            priority: 'Priority',
            status: 'Status',
        },

        service: {
            priority: 'High',
            status: 'Not completed',
        },
    },

    fieldsView: {
        orderId: 'Order',
        pfm: 'PFM Store Code',
        tare: 'Containers in the order',
        orderStatus: 'Status',
        printTransfer: 'Transfer documents',
        partnerOrder: "№ partner's order",
        actions: 'Action',
    },

    filter: {
        filters: {
            orderId: 'Order number',
            pfm: 'PFM Store Code',
            deliveryServiceTypeId: 'Type of delivery',
        },

        buttonClear: 'Clear',
    },

    index: {
        actualIssueDelivery: 'Current',
        noActualIssueDelivery: 'Irrelevant',
    },

    view: {
        h2: 'The task of issuing orders for delivery {description}',
        input: 'PFM Store Code',
        button: ['Form an APP', 'Issued for delivery'],
        tooltip: ['No order has been selected', 'No order has been selected'],
        printTransferDocs: 'Label',
        titleIssueModal: 'Print label?',
        informationText: 'Print the courier service label? After printing, the order will be assigned the status "Ready for shipment"',
        issueModalOk: 'Print',
        issueModalCancel: 'Cancel',
        bvModal: 'Print the APP?',
        textForEmit: 'order | orders',
        emit: [
            // eslint-disable-next-line max-len
            `By {text} №{ordersWithActs} the act has already been formed. Exclude orders marked "the act has been formed" and repeat the action`,
            'Failed to verify the transmitted APP',
            'Unable to get APP',
        ],
        existActs: 'You have unshipped orders!',
        actButton: 'Act',
    },
};